<h2 class="modal-title">Welcome to GatherCo</h2>
<p class="modal-dec">Enter your credentials to access your account</p>
<form [formGroup]="loginForm">
    <div class="form-group">
        <label class="form-label">Email <span class="req">*</span></label>
        <input type="email" class="form-control" placeholder="Enter your email" formControlName="email">
<!--      [pattern]="'^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$'"-->
        @if ((loginForm.controls['email'].hasError('required') && loginForm.controls['email'].touched)){
        <span class="required-message">Please enter your email</span>
        }
        @if (loginForm.controls['email'].value && loginForm.controls['email'].hasError('pattern') &&
        loginForm.controls['email'].touched){
        <span class="required-message">Please enter a valid email address</span>
        }
    </div>
    <div class="form-group">
        <label class="form-label">Password <span class="req">*</span></label>
        <input type="password" class="form-control" placeholder="Enter your password" formControlName="password">
        @if ((loginForm.controls['password'].hasError('required') && loginForm.controls['password'].touched)){
        <span class="required-message">Please enter your password</span>
        }
        @if ((loginForm.controls['password'].hasError('minlength') && loginForm.controls['password'].touched)){
        <span class="required-message">Please enter at least 6 characters</span>
        }
    </div>
    <div class="form-group d-flex align-items-center justify-content-between">
        <label class="custom-checkbox">
            <input type="checkbox" data-md-icheck="">
            <span class="checkmark"></span>
            Remember me
        </label>
        <span class="link" (click)="switchForgotPassword()">Forgot Password?</span>
    </div>
    <div class="form-group">
        <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid" (click)="login()">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Sign in</span>
        </button>
    </div>
    <div class="form-group google-signin-button-container mb-0">
      <!-- Google Sign-In button will be rendered here -->
      <div id="google-signin-button" data-use_fedcm_for_prompt="true" autocomplete="off"></div>
    </div>



</form>
